function previewAccess(email, rules, now = Date.now()) {
  const value = String(email || '').trim().toLowerCase();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Enter a complete email address.';
  if (!rules.find(rule => rule.ruleType === 'company')?.enabled) return 'Denied: this company is disabled.';
  const matches = rules.filter(rule => rule.enabled && (!rule.expiresAtUtc || Date.parse(rule.expiresAtUtc) > now) && ((rule.ruleType === 'email' && rule.value === value) || (rule.ruleType === 'domain' && rule.value === value.split('@')[1])));
  if (matches.some(rule => rule.effect === 'deny')) return 'Denied: a matching deny overrides all allows.';
  if (matches.some(rule => rule.effect === 'allow')) return 'Allowed by an active email or domain rule.';
  return 'Denied: no active allow matches.';
}
module.exports = { previewAccess };
